import { useCallback, useEffect, useState } from 'react';
import { Loader2, RotateCcw } from 'lucide-react';
import { Button } from '../../../components/ui/Button';
import { useToast } from '../../../contexts/ToastContext';
import { obtenerNoEntregables, reprocesar, type NoEntregable } from '../../../services/correoService';
import { mensajeError } from './errores';
import { fmtFecha } from './formato';
import styles from './CorreoModule.module.css';

/** RF-06 — Correos no entregables con su causa y reproceso. */
export default function NoEntregablesCorreoPage() {
  const { addToast } = useToast();
  const [items, setItems] = useState<NoEntregable[]>([]);
  const [cargando, setCargando] = useState(true);
  const [reprocesando, setReprocesando] = useState<string | null>(null);

  const cargar = useCallback(async () => {
    setCargando(true);
    try {
      setItems(await obtenerNoEntregables({}));
    } catch (err) {
      addToast('error', mensajeError(err));
    } finally {
      setCargando(false);
    }
  }, [addToast]);

  useEffect(() => { cargar(); }, [cargar]);

  const reprocesarUno = async (envioId: string) => {
    setReprocesando(envioId);
    try {
      await reprocesar({ envioId });
      addToast('success', 'Correo reencolado para un nuevo intento.');
      await cargar();
    } catch (err) {
      addToast('error', mensajeError(err));
    } finally {
      setReprocesando(null);
    }
  };

  if (cargando) return <div className={styles.vacio}><Loader2 className="spinner" size={28} /></div>;
  if (items.length === 0) return <div className={styles.vacio}>No hay correos no entregables. 🎉</div>;

  return (
    <div className={styles.tablaScroll}>
      <table className={styles.tabla}>
        <thead>
          <tr><th>Fecha</th><th>Tipo</th><th>Asunto</th><th>Intentos</th><th>Motivo</th><th></th></tr>
        </thead>
        <tbody>
          {items.map((e) => (
            <tr key={e.envioId}>
              <td>{fmtFecha(e.fechaRecibidoUtc)}</td>
              <td><span className={styles.chip}>{e.tipo}</span></td>
              <td>{e.asunto}</td>
              <td>{e.intentos}</td>
              <td>{e.motivoFallo ?? '—'}</td>
              <td>
                <Button variant="ghost" size="sm" loading={reprocesando === e.envioId}
                  onClick={() => reprocesarUno(e.envioId)}>
                  <RotateCcw size={15} /> Reprocesar
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
